module.exports = __webpack_public_path__ + "static/media/maeshlogo.750f6e68.png";